<template>
  <div>
    <vue-headful title="Dashboard" />
    <Header page_title="Dashboard" />
    <section v-if="dashboard" class="block">
      <div class="">
        <div class="sd-dashboard-container">
          <div class="sd-row notifications">
            <div class="inner-row container-fluid">
              <div class="sd-top-column">
                <div class="sd-title mini">
                  <div class="title-text"><svg-icon icon="notification_bell" /> Meldingen<span class="notif-number">{{ announcementLength }}</span></div>
                </div>
              </div>
              <div class="announcement-overview">
                <AnnouncementContainer v-if="announcementLength > 0" />
                <div v-else class="empty-notification">Op het moment zijn er geen meldingen</div>
              </div>
            </div>
          </div>
          <div class="sd-row matches">
            <div class="sd-top-column container-fluid">
              <div class="sd-title mini">
                <div class="title-text"><svg-icon icon="heart" /> Matches <span class="notif-number">{{ dashboard.matches_total }}</span></div>
              </div>
              <router-link :to="{ name: 'jobs-match' }" class="text-warning">
                <strong>Bekijk alle matches</strong>
              </router-link>
            </div>
            <div class="sd-job-overview">
              <template v-if="dashboard.matched_jobs.length">
                  <template v-if="user.branch === 1">
                        <job-card-slide
                          v-for="job in dashboard.matched_jobs"
                          :key="job.job_id"
                          :job="job"
                          :all_jobs="dashboard.matched_jobs"
                          :match="true"
                        />
                  </template>
                  <template v-else>
                      <job-card-slide-healthcare
                          v-for="job in dashboard.matched_jobs"
                          :key="job.job_id"
                          :job="job"
                          :all_jobs="dashboard.matched_jobs"
                          :match="true"
                      />
                  </template>
              </template>
              <template v-else>
                <div class="sd-job-item empty">
                  <span>Er zijn geen matches gevonden</span>
                </div>
              </template>
              <div class="final-slide">
                <router-link :to="{ name: 'jobs-match' }" class="all-jobs">
                  <strong class="sd-title">
                    <span class="title-text">
                      <svg-icon icon="heart" />Bekijk alle matches
                    </span>
                  </strong>
                </router-link>
              </div>
            </div>
          </div>
          <div class="sd-row applications">
            <div class="sd-top-column container-fluid">
              <div class="sd-title mini">
                <div class="title-text"><svg-icon icon="suitcase" /> Sollicitaties <span class="notif-number">{{ dashboard.applied_total }}</span></div>
              </div>
              <router-link :to="{ name: 'jobs-pending' }" class="text-warning">
                <strong>Bekijk alle sollicitaties</strong>
              </router-link>
            </div>
            <div class="sd-job-overview">
              <template v-if="dashboard.applied_jobs.length">
                  <template v-if="user.branch === 1">
                      <job-card-slide
                          v-for="job in dashboard.applied_jobs"
                          :key="job.job_id"
                          :job="job"
                          :all_jobs="dashboard.applied_jobs"
                          :applied="true"
                      />
                  </template>
                  <template v-else>
                      <job-card-slide-healthcare
                          v-for="job in dashboard.applied_jobs"
                          :key="job.job_id"
                          :job="job"
                          :all_jobs="dashboard.applied_jobs"
                          :applied="true"
                      />
                  </template>
              </template>
              <template v-else>
                <div class="sd-job-item empty">
                  <span>Er zijn geen openstaande sollicitaties</span>
                </div>
              </template>
              <div class="final-slide">
                <router-link :to="{ name: 'jobs-pending' }" class="all-jobs">
                  <strong class="sd-title">
                    <span class="title-text">
                      <svg-icon icon="suitcase" />Bekijk alle sollicitaties
                    </span>
                  </strong>
                </router-link>
              </div>
            </div>
          </div>
          <div class="sd-row confirmed" v-if="user.sub_branch !== '2' && user.branch !== 3">
            <div class="inner-row container-fluid">
              <div class="sd-top-column">
                <div class="sd-title mini">
                  <div class="title-text"><svg-icon icon="checkmark_circle" /> Bevestigde opdrachten <span class="notif-number">{{ dashboard.approved_total }}</span></div>
                </div>
                <router-link
                  :to="{ name: 'jobs-history' }"
                  class="text-warning"
                >
                  <strong>Bekijk archief</strong>
                </router-link>
              </div>
              <div class="sd-job-list">
                <template v-if="dashboard.approved_jobs.length">
                    <template v-if="user.branch === 1">
                        <job-card-slide
                            v-for="job in dashboard.approved_jobs"
                            :key="job.job_id"
                            :job="job"
                            :all_jobs="dashboard.approved_jobs"
                            :approved="true"
                            overview_type="list"
                        />
                    </template>
                    <template v-else>
                        <job-card-slide-healthcare
                            v-for="job in dashboard.approved_jobs"
                            :key="job.job_id"
                            :job="job"
                            :all_jobs="dashboard.approved_jobs"
                            :approved="true"
                            overview_type="list"
                        />
                    </template>
                </template>
                <template v-else>
                  <div class="sd-job-item empty">
                    <span>Er zijn nog geen bevestigde opdrachten</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-if="!privacy" id="privacy">
      <div class="content text-center">
        <div class="max-600">
          <p class="pt-1 mb-2">
            <i class="material-icons">error_outline</i>
            <strong>Privacy</strong>
          </p>
          <p class="text-14 mb-2">
            <strong class="d-block"
              >We nemen jouw privacy uiteraard heel serieus!</strong
            >We verstrekken bijvoorbeeld nooit gegevens aan derde. Maar we doen
            nog veel meer.
          </p>
          <p class="mb-2 text-14">
            <router-link
              :to="{ name: 'privacy' }"
              title="Lees meer"
              class="text-derect d-inline-block mr-2"
            >
              <strong>Lees meer ></strong>
            </router-link>
            <a
              title="Akkoord"
              class="text-derect d-inline-block ml-2"
              @click="okPrivacy"
            >
              <strong>Akkoord ></strong>
            </a>
          </p>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Achievements from "@/components/Achievements";
import JobCardSlide from "@/components/JobCardSlide.vue";
import JobCard from "@/components/JobCard.vue";
import JobCardSlideHealthcare from "@/components/JobCardSlideHealthcare.vue";

export default {
  components: {
        JobCardSlideHealthcare,
        JobCard,
        JobCardSlide,
        Achievements
  },
  data: function() {
    return {
      user: "",
      announcementLength: '',
      notifs: null,
      dashboard: null,
      // count: {
      //   dates: 0
      // },
      privacy: true,
      rangeValue: 25
    };
  },
  async created() {
    this.refreshLocalUser();

    var experience = [];
    var education = [];
    if (this.user.experience) {
      experience = JSON.parse(this.user.experience);
    }
    if (this.user.education) {
      education = JSON.parse(this.user.education);
    }

    // Is everything okay, after signup
    if(localStorage.getItem("branch") == 1 && localStorage.getItem("subBranch") != '2') {
      if (Object.keys(experience).length < 5 && Object.keys(education).length < 5) {
        //redirect if form-pending
        let form_pending = JSON.parse(localStorage.getItem("form-pending"));
        if (form_pending) {
          this.$router.replace({name: "applicant-step_3", params: {action: "next"}});
        }
      }
    }else if(localStorage.getItem("branch") == 1 && localStorage.getItem("subBranch") == '2') {
      let form_pending = JSON.parse(localStorage.getItem("form-pending"));
      if (form_pending) {
        this.$router.replace({name: "applicant-step_2", params: {action: "save"}});
      }
    }
    else {
      if (Object.keys(experience).length < 5) {
        //redirect if form-pending
        let form_pending = JSON.parse(localStorage.getItem("form-pending"));
        if (form_pending) {
          this.$router.replace({name: "experience-childcare"});
        }
      }
    }
  },
  async mounted() {
    if (JSON.parse(localStorage.getItem("user-token"))) {
      await this.fetchData();
    }
  },
  watch: {
    $route: "fetchData"
  },
  computed: {
    // a computed getter
    firstname: function() {
      return this.user.firstname;
    }
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;

      // await this.checkQuickSteps();

      // this.privacy = JSON.parse(localStorage.getItem("privacy"));
      this.notifs = await this.getTokenAPIList("notifications"); // get notifications
      await this.getTokenAPIList("notifications/seen"); // make the notifications seen
      this.dashboard = await this.getTokenAPIList("applicant/dashboard"); // list of counts
      this.user = JSON.parse(localStorage.getItem("user"));
      // alert(this.user.search_availability);
      // const dates = JSON.parse(this.user.search_availability);
      // if (dates) {
      //   this.count = Object.assign({}, this.count, {
      //     dates: dates.length
      //   });
      // }
      await this.notifications();
      this.$store.state.loading = false;

      jQuery('.sd-job-overview').each(function() {
        let $this = $(this),
          sideSpace = ($('#app').width() - $(this).parent().find('.container-fluid').width()) / 2,
          sidePadding = 0;

        if(jQuery(window).width() < 500)
          sidePadding = 0;

        $this.css('--scrollMargin', ((sideSpace+sidePadding) / 2) + 'px');
        $this.css('paddingLeft', (sideSpace+sidePadding)+'px');
        $this.css('paddingRight', (sideSpace+sidePadding)+'px');
      });

      jQuery(window).on('load resize', function() {
        jQuery('.sd-job-overview').each(function() {
          let $this = $(this),
            sideSpace = ($('#app').width() - $(this).parent().find('.container-fluid').width()) / 2,
            sidePadding = 0;

          if(jQuery(window).width() < 500)
            sidePadding = 0;

          $this.css('--scrollMargin', ((sideSpace+sidePadding) / 2) + 'px');
          $this.css('paddingLeft', (sideSpace+sidePadding)+'px');
          $this.css('paddingRight', (sideSpace+sidePadding)+'px');
        });
      });
    },
    async checkQuickSteps() {
      return new Promise(resolve => {
        if (localStorage.getItem("experience")) {
          this.saveExperience();
        }
        if (localStorage.getItem("education")) {
          this.saveEducation();
        }
        this.updateLocalUser();
        resolve();
      });
    },
    async notifications() {
      this.$store.state.announcement.announcements = [];
      var announcement;

      var experience = [],
          education = [],
          secondaryExperience = [],
          secondaryEducation = [],
          primaryEducationUnansweredExperienceQuestions,
          primaryEducationUnansweredEducationQuestions,
          secondaryEducationUnansweredExperienceQuestions,
          secondaryEducationUnansweredEducationQuestions;

      if(this.user.sub_branch == '1,2')
      {
        if(this.user.experience)
          experience = JSON.parse(this.user.experience);

        if(this.user.education)
          education = JSON.parse(this.user.education);

        if(this.user.second_branch)
        {
          secondaryExperience = JSON.parse(this.user.second_branch).experiences;
          secondaryEducation = JSON.parse(this.user.second_branch).educations;
        }


        // Is everything okay, after signup
        primaryEducationUnansweredExperienceQuestions   = Object.keys(experience).length < 5;
        primaryEducationUnansweredEducationQuestions    = Object.keys(education).length < 5;
        secondaryEducationUnansweredExperienceQuestions = Object.keys(secondaryExperience).length < 5;
        secondaryEducationUnansweredEducationQuestions = Object.keys(secondaryEducation).length < 5;
      }
      else
      {
        if(this.user.experience) {
          experience = JSON.parse(this.user.experience);
        }
        if (this.user.education) {
          education = JSON.parse(this.user.education);
        }

        // Is everything okay, after signup
        if(this.user.sub_branch == '1')
        {
          primaryEducationUnansweredExperienceQuestions   = Object.keys(experience).length < 5;
          primaryEducationUnansweredEducationQuestions    = Object.keys(education).length < 5;
          secondaryEducationUnansweredExperienceQuestions = true;
        }
        if(this.user.sub_branch == '2')
        {
          primaryEducationUnansweredExperienceQuestions   = true;
          primaryEducationUnansweredEducationQuestions    = Object.keys(education).length < 1;
          secondaryEducationUnansweredExperienceQuestions = Object.keys(experience).length < 5;
          secondaryEducationUnansweredEducationQuestions = Object.keys(education).length < 1;
        }
      }

      let today = new Date(),
          voLiveDate = new Date('2024-05-13 13:00:00'),
          verifyDate = new Date(this.user.email_verified_at),
          dateForDifference;

      if(voLiveDate > verifyDate)
        dateForDifference = voLiveDate;
      else
        dateForDifference = verifyDate;

      let dayDifference = Math.round((today.getTime() - dateForDifference.getTime()) / (1000 * 3600 * 24));

      // if(dayDifference < 30 && this.user.sub_branch != '1,2')
      // {
      //   if(primaryEducationUnansweredExperienceQuestions)
      //   {
      //     // Complete your experience.
      //     announcement = {
      //       message:
      //         "Wil je ook werken in het basisonderwijs, vul dan deze vragen in",
      //       link: { name: "applicant-step_2", params: { action: "save", question_branch: '1'} }
      //     };
      //     this.$store.dispatch("announcement/add", announcement, {
      //       root: true
      //     });
      //   }
      //
      //   if(secondaryEducationUnansweredExperienceQuestions)
      //   {
      //     // Complete your experience.
      //     announcement = {
      //       message:
      //         "Wil je ook werken in het voortgezet onderwijs én ben je daarvoor bevoegd? Vul dan deze vragen in.",
      //       link: { name: "applicant-step_2", params: { action: "save", question_branch: '2'} }
      //     };
      //     this.$store.dispatch("announcement/add", announcement, {
      //       root: true
      //     });
      //   }
      // }

      if(primaryEducationUnansweredExperienceQuestions && primaryEducationUnansweredEducationQuestions && this.user.sub_branch !== '2' && this.user.branch !== 3)
      {
        // Complete your education.
        announcement = {
          message:
            "Maak je profiel compleet, zodat je kunt zien welke vacatures we voor je hebben.",
          link: {
            name: "applicant-step_3",
            params: {
              action: "next"
            }
          }
        };
        this.$store.dispatch("announcement/add", announcement, {
          root: true
        });
      }
      else if(primaryEducationUnansweredEducationQuestions && this.user.sub_branch !== '2' && this.user.branch !== 3)
      {
        // Complete your education.
        announcement = {
          message:
            "Vertel ons welke opleiding(en) je hebt gedaan.",
          link: { name: "applicant-step_3", params: { action: "save" } }
        };
        this.$store.dispatch("announcement/add", announcement, {
          root: true
        });
      }

      var keesing = [];
      keesing[0] =
        "Upload hier een foto van je identificatiebewijs.";
      keesing[3] =
        "Je identificatiebewijs kan niet goed gelezen worden. Probeer het nogmaals.";

      if (((this.user["is_keesing"] == 0 && !this.user["id_image"]) || this.user["is_keesing"] == 3) && this.user.sub_branch != '2'  && this.user.branch !== 3)
      {
        announcement = {
          message: keesing[this.user["is_keesing"]],
          link: { name: "applicant-step_1", params: { action: "save" } }
        };
        this.$store.dispatch("announcement/add", announcement, {
          root: true
        });
      }
      else if(this.user["is_keesing"] == 0 && this.user["id_image"] && this.user.sub_branch != '2')
      {
        announcement = {
          message: 'We hebben je identificatiebewijs ontvangen en zullen deze zo snel mogelijk verwerken.',
          link: { name: "applicant-step_1", params: { action: "save" } }
        };
        this.$store.dispatch("announcement/add", announcement, {
          root: true
        });
      }

      if ((this.user.vog_status != "approved" && this.user.vog_status != 'exported') && this.user.sub_branch != '2'  && this.user.branch !== 3) {
        if (this.user.vog_status == "no_file") {
          if (this.user.vog_request == 0 || this.user.vog_request == false) {
            announcement = {
              message: "Vraag hier je VOG aan.",
              link: {name: "applicant-step_1", params: {action: "save"}}
            };
          } else {
            announcement = {
              message: "Je VOG certificaat is aangevraagd. Je kan solliciteren zodra we hem binnen hebben.",
              link: {name: "applicant-step_1", params: {action: "save"}}
            };
          }
        }
        else if (this.user.vog_status == "rejected") {
          announcement = {
            message: "Je VOG certificaat is helaas afgekeurd. Upload een nieuwe of neem contact met ons op.",
            link: {name: "applicant-step_1", params: {action: "save"}}
          };
        }
        else if (this.user.vog_status == "expired") {
          announcement = {
            message: "Je VOG certificaat is verlopen. Upload een nieuwe of neem contact met ons op.",
            link: {name: "applicant-step_1", params: {action: "save"}}
          };
        }
        else if (this.user.vog_status == "pending") {
          announcement = {
            message: "We hebben jouw VOG certificaat ontvangen. We controleren hem zo snel mogelijk.",
            link: {name: "applicant-step_1", params: {action: "save"}}
          };
        }
        this.$store.dispatch("announcement/add", announcement, {
          root: true
        });
      }

        if ((this.user.branch === 3 && !this.user.healthcare_availability) ||
            (this.user.branch !== 3 && !this.searchAvailabilityStillCurrent())) {

          if(this.user.branch === 3) {
            announcement = {
              message: "Geef hier de tijden/dagdelen door waarvoor je beschikbaar bent",
              link: { name: "availability" }
            }
          } else {
            announcement = {
              message: "Geef hier de dagen door waarop je beschikbaar bent.",
              link: { name: "availability" }
            };
          }

        this.$store.dispatch("announcement/add", announcement, {
          root: true
        });
      }

      if ((this.user.branch !== 3 && this.user["salary_id"] <= 0) || (this.user.branch === 3 && this.user.salary_per_hour === '0.00')) {
        announcement = {
          message: "Vul hier je uurloon of uurtarief in.",
          link: { name: "salary-details" }
        };
        this.$store.dispatch("announcement/add", announcement, {
          root: true
        });
      }

      // if (this.user["has_diplomas"] != true && this.user.sub_branch != '1') {
      //   announcement = {
      //     message: "We ontvangen graag een digitale kopie of foto van je diploma(‘s)",
      //     link: { name: "applicant-diplomas" }
      //   };
      //   this.$store.dispatch("announcement/add", announcement, {
      //     root: true
      //   });
      // }

      if (this.user["branch"] == 2 && this.user.prk_status !== "approved") {
        if (this.user.prk_status === "no_file") {
          announcement = {
            message: "Upload je bewijs van inschrijving PRK zodat je kan solliciteren.",
            link: {name: "applicant-step_1", params: {action: "save"}}
          };
        }
        else if (this.user.prk_status === "pending") {
          announcement = {
            message: "We hebben je bewijs van inschrijving PRK ontvangen. We controleren hem zo snel mogelijk!",
            link: {name: "applicant-step_1", params: {action: "save"}}
          };
        }
        else if (this.user.prk_status === "rejected") {
          announcement = {
            message: "Je bewijs van inschrijving PRK is afgekeurd. Upload snel een nieuwe.",
            link: {name: "applicant-step_1", params: {action: "save"}}
          };
        }
        this.$store.dispatch("announcement/add", announcement, {
          root: true
        });
      }

      if (this.user["customer_type"] == 1 && this.user.zzp_kvk_status !== "approved" && this.user.sub_branch != '2' && this.user.branch !== 3) {
        if (this.user.zzp_kvk_status === "no_file") {
          announcement = {
            message: "We hebben jouw KVK-uittreksel nodig voordat je kan solliciteren. Upload hem hier.",
            link: { name: "zzpdocs" }
          };
        }
        else if (this.user.zzp_kvk_status === "pending") {
          announcement = {
            message: "We controleren jouw KVK-uittreksel zo snel mogelijk!",
            link: { name: "zzpdocs" }
          };
        }
        else if (this.user.zzp_kvk_status === "rejected") {
          announcement = {
            message: "Je KVK-uittreksel is afgekeurd. Upload snel een nieuwe.",
            link: { name: "zzpdocs" }
          };
        }
        else if (this.user.zzp_kvk_status === "expired") {
          announcement = {
            message: "Je KVK-uittreksel is verlopen. Upload snel een nieuwe.",
            link: { name: "zzpdocs" }
          };
        }
        if (announcement != null) {
          this.$store.dispatch("announcement/add", announcement, {
            root: true
          });
        }
      }

      if (this.user["customer_type"] == 1 && this.user.zzp_liability_insurance_status == "no_file" && this.user.sub_branch != '2' && this.user.branch !== 3) {
        announcement = {
          message: "Upload een bewijs van jouw aansprakelijkheidsverzekering.",
          link: { name: "zzpdocs" }
        };
        this.$store.dispatch("announcement/add", announcement, {
          root: true
        });
      }

      this.announcementLength = this.$store.state.announcement.announcements.length;
    },
    okPrivacy() {
      localStorage.setItem("privacy", JSON.stringify(true));
      this.privacy = true;
    },
    clickedNotif(obj) {
      console.log(obj);
    },
    toggleAchievementInfo(achievementID) {
      this.showAchievementInfo = achievementID;
    },
    searchAvailabilityStillCurrent() {
      if (this.user.search_availability) {
        var dates = JSON.parse(this.user.search_availability);

        if(Array.isArray(dates))
          var lastDate = dates.pop();
        else
          var lastDate = dates[Object.keys(dates)[Object.keys(dates).length - 1]];

        return new Date(lastDate).getTime() > (new Date().getTime() - (24 * 60 * 60 * 1000));
      }
      return false;
    }
  }
};
</script>

<style scoped>
.announcement-overview {
  background-color: #F6F6F6;
  padding: 20px;
  border-radius: 10px;
}

.sd-row .notif-number {
  background-color: #FFCD00;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 25px;
  height: 25px;
  border-radius: 100%;
  color: #FFF;
  font-weight: 400;
  font-size: 12px;
  line-height: 1;
  margin-left: 10px;
}

.sd-row.notifications .empty-notification {
  background-color: #FFF;
  border-radius: 10px;
  padding: 15px;
  color: #64513D;
  text-align: center;
}

.sd-top-column .text-warning {
  text-align: right;
  font-size: 14px;
}

.sd-row.matches .sd-top-column {
  margin-bottom: 10px;
}

.sd-row.matches .sd-job-overview,
.sd-row.applications .sd-job-overview {
  padding-top: 10px;
}

.sd-row.applications .sd-job-overview {
  margin-top: -10px;
}

.sd-row .sd-job-overview {
  position: relative;
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: auto !important;
  scrollbar-color: #FFCD00 #FFF;
  scrollbar-width: thin;
}

/deep/.sd-row .sd-job-overview .sd-job-card {
  //margin-bottom: 10px;
}

.sd-row .sd-job-overview {
  --scrollMargin: 50px;
}

.sd-row .sd-job-overview::-webkit-scrollbar {
  height: 8px;
}

.sd-row .sd-job-overview::-webkit-scrollbar-track {
  background-color: #FFF;
  border-radius: 8px;
  outline: 2px solid #E1E1F533;
}

.sd-row .sd-job-overview::-webkit-scrollbar-button:start {
  background-color: transparent;
  width: var(--scrollMargin);
}

.sd-row .sd-job-overview::-webkit-scrollbar-button:end {
  background-color: transparent;
  width: var(--scrollMargin);
}

.sd-row .sd-job-overview::-webkit-scrollbar-thumb {
  background-color: #FFCD00;
  height: 8px;
  border-radius: 8px;
  cursor: pointer;
  width: 200px;
}

/deep/.sd-job-overview .sd-job-item {
  height: 100%;
  width: 230px;
}

/deep/.sd-job-overview .sd-job-item a {
  height: 100%;
}

.sd-job-overview .sd-job-item.empty,
.sd-job-list .sd-job-item.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  border: 2px solid #F6F6F6;
  border-radius: 10px;
  background-color: #FFF;
  color: #64513D;
  padding: 15px;
  margin-right: 15px;
  min-width: 230px;
  height: unset;
}

/*/deep/.sd-job-overview .final-slide {
  margin-bottom: 10px;
}*/

/deep/.sd-job-overview .final-slide a {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  background-color: #F6F6F6;
  border-radius: 10px;
  height: 100%;
  width: 230px;
  padding: 27px 15px;
  color: #64513D;
  font-size: 14px;
}

/deep/.sd-job-overview .final-slide a svg {
  color: #64513D;
}

.sd-job-list {
  margin-top: 20px;
  padding: 20px;
  background-color: #F6F6F6;
  border-radius: 10px;
}

/deep/.sd-job-list .sd-job-card:not(:last-child) {
  margin-bottom: 15px;
}

/deep/.sd-job-list .sd-job-item {
  width: 100%;
}

/deep/.sd-job-list .sd-job-item a {
  margin-right: 0;
}

.achievements_container.noAvatar {
  right: 85px;
}

span.photo-comment {
  top: -7px;
  right: 107px;
}
img.arrow {
  transform: scaleX(-1) rotate(52deg);
  width: 28px;
  top: 12px;
  right: 95px;
}
</style>